import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import ReactFlagsSelect from "react-flags-select";
import { FiArrowRight } from "react-icons/fi";
import FlowSteps from "../components/guide/FlowSteps";
import "./styles/flow-form.css";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";

// Validation schema
const validationSchema = Yup.object({
  businessCountry: Yup.string().required("Le pays est requis"),
});

const OHADA_COUNTRIES = [
  "BJ",
  "BF",
  "CM",
  "CF",
  "KM",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GN",
  "GW",
  "ML",
  "NE",
  "SN",
  "TD",
  "TG",
];

function BusinessCountry() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);

  // Countries offered depend on the service being ordered
  const countries =
    cart.from === "creation" || cart.from === "admin"
      ? ["CM"]
      : cart.from === "domiciliation"
        ? OHADA_COUNTRIES
        : undefined;

  return (
    <div className="flow-form-page">
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          {cart.from === "creation" ? (
            <>
              Dans quel <span>pays</span> souhaitez-vous créer votre entreprise
              ?
            </>
          ) : (
            <>
              Dans quel <span>pays</span> se situe votre entreprise ?
            </>
          )}
        </h1>
      </header>

      <Formik
        initialValues={{
          businessCountry: cart.businessCountry || "",
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          await dispatch(
            addToCart({
              businessCountry: values.businessCountry,
            }),
          );
          navigate("/business-type");
        }}
      >
        {({ setFieldValue, errors, touched, values }) => (
          <Form className="flow-form" noValidate>
            <div className="flow-field">
              <span className="flow-label">Pays de l'entreprise</span>
              <ReactFlagsSelect
                selected={values.businessCountry}
                countries={countries}
                onSelect={(code) => setFieldValue("businessCountry", code)}
                placeholder="Choisissez le pays"
                searchable
                searchPlaceholder="Recherchez le pays"
                className="flow-flags"
              />
              {errors.businessCountry && touched.businessCountry && (
                <p className="flow-error">{errors.businessCountry}</p>
              )}
            </div>

            <div className="flow-actions">
              <button type="submit" className="flow-submit">
                Continuer <FiArrowRight aria-hidden="true" />
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <FlowSteps flow={cart.from} />
    </div>
  );
}

export default BusinessCountry;
